export function NewsletterWeekRows({ weeks, labels }) {
  if (!weeks?.length) return null;
  return (
    <section className="pingflo-section">
      <h2>{labels.title}</h2>
      <ol className="pingflo-weeks">
        {weeks.map((week) => (
          <li key={week.week_start}>
            <p className="pingflo-week-date">{labels.range(week.week_start, week.week_end)}</p>
            {week.empty ? (
              <p className="pingflo-quiet">{labels.empty}</p>
            ) : (
              <ul>
                {(week.best || []).map((row) => (
                  <li key={`${week.week_start}-${row.kind}-${row.name}`}>
                    <span className="pingflo-name">{row.name}</span>
                    <span className={`pingflo-metric${row.is_personal_best ? " is-pb" : ""}`}>
                      {row.value} {labels.unit(row)}
                    </span>
                    {row.group_name ? <span className="pingflo-group">{row.group_name}</span> : null}
                  </li>
                ))}
                {!week.best?.length ? <li className="pingflo-quiet">{labels.noHighlight}</li> : null}
              </ul>
            )}
          </li>
        ))}
      </ol>
    </section>
  );
}
